module.exports = __webpack_public_path__ + "0d5d4109e340171e31e3b92e9d071c60.png";